import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import ServiceMain from "./service-main";
import ServiceExcel from "./service-excel";
import ServiceMonitoring from "./service-monitoring";
import "./service-monitoring.css";

const Service = ({ page = "main" }) => {
  const navigate = useNavigate();

  const tabs = [
    { key: "main", label: "Общие", path: "/service", component: <ServiceMain /> },
    { key: "excel", label: "Импорт Excel", path: "/service-excel", component: <ServiceExcel /> },
    { key: "monitoring", label: "Мониторинг статусов", path: "/service-monitoring", component: <ServiceMonitoring /> },
  ];

  const activeTab = tabs.find(t => t.key === page)?.key || tabs[0].key;

  const onTabChange = (key) => {
    const tab = tabs.find(t => t.key === key);
    if (tab) {
      navigate(tab.path);
    }
  };

  return (
    <div className="sport-form-content service-page" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        items={tabs.map(tab => ({ key: tab.key, label: tab.label }))}
        style={{ marginBottom: 0, flexShrink: 0 }}
      />
      <div className="service-page-content">
        {tabs.find(t => t.key === activeTab)?.component}
      </div>
    </div>
  );
}

export default Service;